import { format as dateFnsFormat } from "date-fns";
import { ka, enUS } from "date-fns/locale";

type Language = "en" | "ka";

const locales = {
  en: enUS,
  ka: ka,
};

/**
 * Format date with language-aware locale
 */
export const formatDate = (
  date: Date | string | number,
  formatStr: string,
  language: Language = "en"
): string => {
  const dateObj = typeof date === "string" || typeof date === "number" ? new Date(date) : date;
  return dateFnsFormat(dateObj, formatStr, { locale: locales[language] });
};

/**
 * Format date for display in tables (short format)
 */
export const formatTableDate = (date: Date | string, language: Language = "en"): string => {
  return formatDate(date, "MMM dd, yyyy", language);
};

/**
 * Format time for display
 */
export const formatTime = (date: Date | string, language: Language = "en"): string => {
  return formatDate(date, "HH:mm", language);
};

/**
 * Format date and time together
 */
export const formatDateTime = (date: Date | string, language: Language = "en"): string => {
  return formatDate(date, "MMM dd, yyyy HH:mm", language);
};

/**
 * Format date for detailed view (long format)
 */
export const formatDetailDate = (date: Date | string, language: Language = "en"): string => {
  return formatDate(date, "PPP", language);
};

/**
 * Format date for date range display
 */
export const formatDateRange = (date: Date | string, language: Language = "en"): string => {
  return formatDate(date, "LLL dd, y", language);
};
